<div *ngIf='subParetoDataLength > 0' style="display: none;">  
        <app-subpareto-chart  [GraphData]="subParetoData" [GraphId]="pareto_sub" ></app-subpareto-chart>
</div>